import { render, staticRenderFns } from "./HomePayers.vue?vue&type=template&id=522701a6&scoped=true"
import script from "./HomePayers.vue?vue&type=script&lang=js"
export * from "./HomePayers.vue?vue&type=script&lang=js"
import style0 from "./HomePayers.vue?vue&type=style&index=0&id=522701a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522701a6",
  null
  
)

export default component.exports